import { localStorageEnum } from 'types';
import { ThemeKeyType } from './slice/types';

/* istanbul ignore next line */
export const isSystemDark = window?.matchMedia
  ? window.matchMedia('(prefers-color-scheme: dark)')?.matches
  : undefined;

export function saveTheme(theme: ThemeKeyType) {
  localStorage?.setItem(localStorageEnum.selectedTheme, theme);
}

/* istanbul ignore next line */
export function getThemeFromStorage(): ThemeKeyType | null {
  return window.localStorage
    ? (localStorage.getItem(localStorageEnum.selectedTheme) as ThemeKeyType) ||
        null
    : null;
}
